import { Typography, TextField } from 'ui/atoms';
import { useStyles } from './StripeInfoCard.styles';
import { useLocale } from 'hooks/useLocale/useLocale';
import { Controller, useForm } from 'react-hook-form';
import { CheckoutFormValue } from './StripeInfoCard.types';
import { schema } from './StripeInfoCard.utils';

import { joiResolver } from '@hookform/resolvers/joi';

interface Props {
  nameCheck: string;
  emailCheck: string;
  setEmailCheck: (name: string) => void;
  setNameCheck: (name: string) => void;
}

export const StripeInfoCard = ({ emailCheck, nameCheck, setEmailCheck, setNameCheck }: Props) => {
  const styles = useStyles();

  const { formatMessage } = useLocale();

  const { control, errors } = useForm<CheckoutFormValue>({
    reValidateMode: 'onChange',
    resolver: joiResolver(schema),
    mode: 'onChange',
    defaultValues: {
      email: emailCheck,
      purchaserName: nameCheck,
    },
  });

  if (errors.email) {
    setNameCheck('');
    setEmailCheck('');
  } else {
    setNameCheck(nameCheck);
    setEmailCheck(emailCheck);
  }

  return (
    <div className={styles.container}>
      <Typography variant="h5" className={styles.detailText}>
        {formatMessage({ id: 'checkout.payment_page.details' })}
      </Typography>
      <div>
        <Typography className={styles.header} variant="body1">
          Name <span className={styles.required}>*</span>
        </Typography>
        {/* <Controller
          control={control}
          rules={{
            required: true,
          }}
          render={() => <div className={styles.hidden} />}
          name="isClipSelected"
        /> */}
        <Controller
          control={control}
          rules={{
            required: true,
          }}
          render={({ onChange, value, onBlur }) => (
            <TextField
              size="small"
              onChange={onChange}
              onBlur={onBlur}
              disabled={true}
              value={value || nameCheck}
              className={styles.paymentTextField}
              variant="outlined"
              placeholder="Enter your name"
              error={!!errors?.purchaserName}
              helperText={errors?.purchaserName?.message}
            />
          )}
          name="purchaserName"
        />
      </div>
      <div>
        <Typography className={styles.header} variant="body1">
          Email address <span className={styles.required}>*</span>
        </Typography>
        <Controller
          control={control}
          rules={{
            required: true,
          }}
          render={({ onChange, value, onBlur }) => (
            <TextField
              size="small"
              onChange={onChange}
              onBlur={onBlur}
              disabled={true}
              value={value || emailCheck}
              className={styles.paymentTextField}
              variant="outlined"
              placeholder="Enter your email address"
              error={!!errors?.email}
              helperText={errors?.email?.message}
            />
          )}
          name="email"
        />
      </div>
    </div>
  );
};
